import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { WAREHOUSES_PATH } from '../../core/constants';

export const getWarehouseStockAction = createAsyncThunk(
    'inventory/getWarehouseStockAction',
    async (warehouseId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ WAREHOUSES_PATH }/${ warehouseId }/stock`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getWarehouseStockSlice = createSlice({
    name: 'getWarehouseStockSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getWarehouseStockAction.pending, () => STATE__API__STARTED);
        builder.addCase(getWarehouseStockAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getWarehouseStockAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getWarehouseStockState = (state) => state.inventory.getWarehouseStock;
export default getWarehouseStockSlice.reducer;
